<template>
  <div class="visual">
    <v-img :class="isSP ? 'visual__img--sp' : 'visual__img--pc'"
           :src="require('@/assets/img/visual.jpeg')" contain />
    <h1 :class="isSP ? 'visual__title--sp' : 'visual__title--pc'">フードロスを活用した飲食店</h1>
    <p :class="isSP ? 'visual__about--sp' : 'visual__about--pc'">
      Trash Kitchenは大分県別府市で、３ヶ月限定で営業していた<br>
      フードロス、規格外野菜、食料廃棄問題に取り組む飲食店です。
    </p>
    <a :class="isSP ? 'visual__link--sp' : 'visual__link--pc'"
       href="https://nukumo.link" target="_blank">nukumoのホームページはこちら</a>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * @return {Boolean} SPかどうか
     */
    isSP () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
        navigator.userAgent
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';
@import '@/assets/sass/color.scss';

.visual {
  width: 100vw;
  text-align: center;
  &__img {
    margin: 0 auto;
    &--sp {
      @extend .visual__img;
      width: 150px;
      min-height: 150px;
    }
    &--pc {
      @extend .visual__img;
      width: 400px;
      min-height: 400px;
    }
  }
  &__title {
    margin: 0;
    &--sp {
      @extend .visual__title;
      margin-top: 20px;
      font-size: 2rem;
    }
    &--pc {
      @extend .visual__title;
      margin-top: 30px;
      font-size: 3.6rem;
    }
  }
  &__about {
    margin: 0;
    &--sp {
      @extend .visual__about;
      margin-top: 20px;
      font-size: 1rem;
    }
    &--pc {
      @extend .visual__about;
      margin-top: 20px;
      font-size: 1.8rem;
    }
  }
  &__link {
    display: block;
    color: $black_color;
    text-decoration: underline;
    &--sp {
      @extend .visual__link;
      margin-top: 40px;
      font-size: 1.3rem;
    }
    &--pc {
      @extend .visual__link;
      margin-top: 40px;
      font-size: 1.8rem;
    }
  }
}
</style>
